<template>
  <div class="custom_header_dialog">
    <el-dialog
      :title="`自定义表头`"
      :visible.sync="customHeaderDialog"
      width="50%"
      @close="closeCustomHeader"
      class="dialog_title"
    >
      <!-- 个人信息显示 -->
      <section class="header-title" v-if="userArr.length > 0">
        个人信息显示
      </section>
      <el-row>
        <el-col
          :span="6"
          v-for="(item, index) in userArr"
          :key="item.id"
          class="mt8"
        >
          <div class="conditions">
            <el-checkbox
              v-model="item.is_show"
              :checked="item.is_show"
              :label="item.c_name"
            ></el-checkbox>
          </div>
        </el-col>
      </el-row>
      <!-- 统计等其他信息展示 -->
      <section class="header-title mt18" v-if="otherArr.length > 0">
        统计等其他信息展示
      </section>
      <el-row>
        <el-col
          :span="6"
          v-for="(item, index) in otherArr"
          :key="item.id"
          class="mt8"
        >
          <div class="conditions">
            <el-checkbox
              v-model="item.is_show"
              :checked="item.is_show"
              :label="item.c_name"
            ></el-checkbox>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  EditorQuestionHeader,
  CustomHeader,
  ScoreMngCustom,
  StudyCustomHeader,
} from "@/api/tearcher";
import {
  ClassStaffHeaderShowCustom,
  SatisfactionCustomList,
  SelectCustomHeader,
  FillDetailCustomHeader,
  BaseSchoolSatisfactionCustomHeader,
  CheckWorkAttendanceDetailCustomList,
  StudyAchievementCommitDetailCustomList,
  TrainEffectStudyScoreCustomList
} from "@/api/projectAdministrator";
export default {
  props: {
    // 2:成绩管理的自定义表头
    // is_who: {
    //   type: Number,
    //   default: 1,
    // },
    scoreMng: {
      type: String,
    },
  },
  data() {
    return {
      customHeaderDialog: false,
      userArr: [],
      otherArr: [],
      is_who: 1,
      fn: "",
      id: "",
    };
  },
  methods: {
    //   changeShowAccountStatus(item){
    //       item.is_show = !item.is_show;
    //   },
    // 操作dialog
    operationDialog(class_id, is_who, fn, id) {
      this.customHeaderDialog = true;
      this.is_who = is_who;
      this.fn = fn;
      this.id = id;
      //   console.log(this.is_who,'this.is_who');
      if (this.is_who === 2) {
        if (this.scoreMng === "achievement") {
          // 成绩管理的自定义表头(成绩册)
          ScoreMngCustom().then((res) => {
            this.userArr = res.data.user;
            this.otherArr = res.data.other;
            // 修改is_show的值
            this.userArr.map((item) => {
              item.is_show = item.is_show == 1 ? true : false;
            });
            this.otherArr.map((item) => {
              item.is_show = item.is_show == 1 ? true : false;
            });
          });
        } else {
          // 成绩管理的自定义表头(学习情况明细)
          StudyCustomHeader().then((res) => {
            this.userArr = res.data.user;
            this.otherArr = res.data.other;
            // 修改is_show的值
            this.userArr.map((item) => {
              item.is_show = item.is_show == 1 ? true : false;
            });
            this.otherArr.map((item) => {
              item.is_show = item.is_show == 1 ? true : false;
            });
          });
        }
      } else if (this.is_who === 3) {
        // 学员报告
        ClassStaffHeaderShowCustom({ class_id: class_id }).then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      } else if (this.is_who === 4) {
        // 专家报告满意度统计
        SatisfactionCustomList({ class_id: class_id }).then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      } else if (this.is_who === 5) {
        // 专家选择题明细 / 基地校选择题列表自定义表头
        SelectCustomHeader({ class_id: class_id }).then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      } else if (this.is_who === 6) {
        // 填空题详细自定义表头
        FillDetailCustomHeader().then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      }else if (this.is_who === 7) {
        // 基地校满意度统计自定义表头
        BaseSchoolSatisfactionCustomHeader().then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      }
      else if (this.is_who === 8) {
        // 考勤报告出勤明细自定义表头
        CheckWorkAttendanceDetailCustomList({ class_id: class_id }).then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      }else if (this.is_who === 9) {
        // 学习成果报告作业/问卷提交情况明细自定义表头
        StudyAchievementCommitDetailCustomList({ class_id: class_id }).then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      }else if (this.is_who === 10) {
        // 培训效果报告成绩得分统计列表自定义表头
        TrainEffectStudyScoreCustomList({ class_id: class_id }).then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      }
      else {
        // 人员管理的自定义表头
        CustomHeader().then((res) => {
          this.userArr = res.data.user;
          this.otherArr = res.data.other;
          // 修改is_show的值
          this.userArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
          this.otherArr.map((item) => {
            item.is_show = item.is_show == 1 ? true : false;
          });
        });
      }
    },
    // 确 定
    submitForm() {
      let postData = [...this.userArr, ...this.otherArr];
      postData = JSON.parse(JSON.stringify(postData));
      postData.map((item) => {
        item.is_show = item.is_show ? 1 : 2;
      });
      // 列表头部修改
      EditorQuestionHeader({ data: postData })
        .then((response) => {
          if (response.error_code === 201) {
            this.messageTips("设置成功", "success");
            // this.$emit("handleAnswerDetails");
            if (this.id) {
              this.fn(this.id);
            } else {
              this.fn();
            }

            this.cancel();
          }
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
    // 取 消
    cancel() {
      this.customHeaderDialog = false;
    },
    // 窗口关闭
    closeCustomHeader() {
      this.reset();
    },
    // 数组重置
    reset() {
      this.userArr = [];
      this.otherArr = [];
    },
  },
};
</script>
 
<style lang = "less" scoped>
.custom_header_dialog {
  .header-title {
    font-size: 14px;
    margin-bottom: 10px;
    color: #303133;
    background-color: #f2f2f2;
    padding: 10px;
  }
}
</style>